import { createReducer } from 'redux-act';

import * as actions from '../actions/liability';

import { getImage } from '../utils/images';

const DEFAULT_STATE = {
  liabilityItems: null,
  liabilityStatus: null,
  timeline: null,
  satisfaction: [],
  surveyUrl: null,
  logo: null
};

export default createReducer(
  {
    [actions.setLiability]: (state, liability) => {
      const timeline = liability.timeline.map(
        ({ logo_url: logo, current_stage, ...rest }) => {
          if (logo && logo[0] === '/') {
            logo = getImage(logo);
          }
          const timelineItem = {
            logo: logo,
            current: current_stage,
            ...rest
          };
          if (!timelineItem.logo) {
            timelineItem.label = liability.mandant.name;
          }
          return timelineItem;
        }
      );

      return {
        timeline: timeline,
        surveyUrl: liability.surveyUrl,
        satisfaction: liability.satisfaction,
        liabilityItems: liability.liability_items,
        liabilityStatus: liability.liability_status,
        logo: liability.category.logourl && getImage(liability.category.logourl)
      };
    },
    [actions.liabilityReset]: state => {
      return { ...DEFAULT_STATE };
    }
  },
  DEFAULT_STATE
);
